<template>
    <div>
        <div class="box view-nav-bar">
            <b-form-input v-model="from"
                          class="transparent-input"
                          type="date"
                          placeholder="From"/>
            <b-form-input v-model="to"
                          class="transparent-input"
                          type="date"
                          placeholder="To"/>

            <b-pagination v-if="totalRows !== null"
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          aria-controls="adm-day-table"/>
        </div>

        <div class="box">
            <div :class="'box-content pt-3' + (totalRows ? '' : ' d-none')">
                <b-table ref="dataTable"
                         id="adm-day-table"
                         class="shx-table w-100"
                         hover dark fixed
                         sort-icon-left
                         :busy="fetching"
                         :fields="columns"
                         :sort-by.sync="sortBy"
                         :sort-desc.sync="sortDesc"
                         :currentPage="currentPage"
                         :perPage="0"
                         :items="fetchData">

                    <template #cell(admissions)="data">
                        <span>{{ formatInt(data.item.admissions) }}</span>
                    </template>

                    <template #cell(actions)="data">
                        <button @click="data.toggleDetails" class="btn btn-link">
                            <icon :name="'chevron-' + (data.detailsShowing ? 'up' : 'down')"/>
                        </button>
                    </template>

                    <template #row-details="data">
                        <admissions-cinemas-table bucket="day" :parent-key="data.item.day"/>
                    </template>

                    <template #table-busy>
                        <table-spinner/>
                    </template>
                </b-table>
            </div>

            <div v-if="!totalRows" class="box-content pt-4 text-center text-muted">No admissions yet.</div>
        </div>

        <div class="box">
            <b-pagination v-if="totalRows !== null"
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          aria-controls="adm-day-table"/>
        </div>
    </div>
</template>

<script>
import {BFormInput, BPagination, BTable} from "bootstrap-vue";
import axios from "axios";
import dayjs from "dayjs";
import helpers from "../../helpers/helpers";
import TableSpinner from "../../partials/TableSpinner";
import AdmissionsCinemasTable from "../../partials/AdmissionsCinemasTable";
import dataTableLoading from "../../mixins/data-table-loading";

export default {
    components: {
        AdmissionsCinemasTable,
        TableSpinner,
        BFormInput,
        BPagination,
        BTable,
    },
    mixins: [
        dataTableLoading
    ],
    data() {
        const params = helpers.getCurrentUrlQuery();

        this.columns = [
            {key: 'day', label: 'Day', sortable: true, thClass: 'shx-th-120'},
            {key: 'week_code', label: 'Week', sortable: false, thClass: 'shx-th-100'},
            {key: 'admissions', label: 'Admissions', sortable: true, thClass: 'text-right', tdClass: 'text-right'},
            {key: 'cinemas', label: '# Cinemas', sortable: true, thClass: 'text-right shx-th-100', tdClass: 'text-right'},
            {key: 'titles', label: '# Titles', sortable: true, thClass: 'text-right shx-th-100', tdClass: 'text-right'},
            {key: 'actions', label: '', thClass: 'shx-th-60', tdClass: 'p-0 text-center align-middle'},
        ];

        const today = dayjs().format('YYYY-MM-DD');
        const monthAgo = dayjs().subtract(1, 'month').format('YYYY-MM-DD');

        return {
            fetching: false,
            from: params.from || monthAgo,
            to: params.to || today,
            currentPage: +params.page || 1,
            perPage: this.$config.tableRows,
            totalRows: null,
            sortBy: params.sortBy || 'day',
            sortDesc: params.sort ? params.sort === 'desc' : true,
        }
    },
    watch: {
        from() {
            this.currentPage = 1;
            this.$refs.dataTable.refresh();
        },
        to() {
            this.currentPage = 1;
            this.$refs.dataTable.refresh();
        },
    },
    methods: {
        fetchData(ctx, callback) {
            this.tableLoading(true);

            axios
                .get('/admissions/day', {
                    params: {
                        ...this.from && {from: this.from},
                        ...this.to && {to: this.to},
                        orderBy: ctx.sortBy,
                        order: ctx.sortDesc ? 'desc' : 'asc',
                        page: ctx.currentPage,
                    }
                })
                .then(response => {
                    callback(response.data.data.rows);
                    this.totalRows = response.data.data.total;
                })
                .then(() => {
                    this.tableLoading(false).replaceCurrentUri(ctx);
                })
                .catch(error => {
                    this.tableLoading(false).$toast.error(error.message);
                });
        },
        replaceCurrentUri(ctx) {
            this.$router.replace({
                name: 'AdmissionsByDay',
                query: {
                    ...this.from && {from: this.from},
                    ...this.to && {to: this.to},
                    sortBy: ctx.sortBy,
                    sort: ctx.sortDesc ? 'desc' : 'asc',
                    page: ctx.currentPage,
                }
            });
        },
        formatInt(v) {
            return (v || 0).toLocaleString();
        },
    }
}
</script>
